// extracted by mini-css-extract-plugin
export default {"label":"ApiTokensList_label__vEYPN"};